import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ErrorOutlineSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "6.6 7 67 66",
  color = "#236998",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        d="M30.3427 72.1747H49.6286C54.0915 72.1747 55.992 70.7126 58.2273 68.3097L70.6656 54.7035C72.7857 52.384 73.3334 50.8665 73.3334 47.6209V32.379C73.3334 29.1334 72.7857 27.6159 70.6656 25.2964L58.2273 11.6901C55.992 9.28721 54.0915 7.8251 49.6286 7.8251H30.3427C25.9086 7.8251 23.9792 9.28721 21.7728 11.6901L9.30558 25.2964C7.21446 27.6159 6.66675 29.1334 6.66675 32.379V47.6209C6.66675 50.8665 7.21446 52.384 9.30558 54.7035L21.7728 68.3097C23.9792 70.7126 25.9086 72.1747 30.3427 72.1747ZM31.8044 67.5432C28.2503 67.5432 27.3024 66.7357 25.2913 64.5859L13.5789 51.85C12.2697 50.3993 11.9764 49.5251 11.9764 47.1134V32.8865C11.9764 30.4748 12.2697 29.6006 13.5789 28.1498L25.2913 15.414C27.3024 13.2642 28.2503 12.4566 31.8044 12.4566H48.1668C51.7498 12.4566 52.6977 13.2642 54.7089 15.414L66.3924 28.1498C67.7304 29.6006 68.0238 30.4748 68.0238 32.8865V47.1134C68.0238 49.5251 67.7304 50.3993 66.3924 51.85L54.7089 64.5859C52.6977 66.7357 51.7498 67.5432 48.1668 67.5432H31.8044ZM39.9791 45.8972C41.3914 45.8972 42.2153 45.0473 42.2442 43.5253L42.6561 26.0838C42.685 24.5618 41.5301 23.4516 39.9502 23.4516C38.3703 23.4516 37.2443 24.5328 37.2732 26.0549L37.6851 43.5253C37.714 45.0473 38.538 45.8972 39.9791 45.8972ZM39.9791 56.3182C41.7597 56.3182 43.2759 54.8786 43.2759 53.137C43.2759 51.3405 41.7887 49.9559 39.9791 49.9559C38.1826 49.9559 36.7113 51.3694 36.7113 53.137C36.7113 54.8497 38.2115 56.3182 39.9791 56.3182Z"
        fill={color}
      />
    </svg>
  );
};

export { ErrorOutlineSvg };
